import type { Progress } from '@openeducation/oe-it-shared-types';

import ProgressDao from '../dao/progress.dao';
import type { Environment } from '../interfaces/environment';

export abstract class ProgressService {
  static async getProgress(
    env: Environment,
    personId: number
  ): Promise<Progress> {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await ProgressDao.getProgress(env, personId);
  }
}
